import { useState, useEffect } from "react";

interface UptimeStatus {
  status: "operational" | "degraded" | "down" | "loading";
  label: string;
}

export function useUptimeStatus(): UptimeStatus {
  const [status, setStatus] = useState<UptimeStatus>({ status: "loading", label: "Checking status..." });

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/uptime-status`;
        const res = await fetch(url, {
          headers: {
            apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
          },
        });

        if (!res.ok) {
          setStatus({ status: "operational", label: "All systems operational" });
          return;
        }

        const data = await res.json();
        setStatus({ status: data.status, label: data.label });
      } catch {
        setStatus({ status: "operational", label: "All systems operational" });
      }
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 60000);
    return () => clearInterval(interval);
  }, []);

  return status;
}
